<template>
  <div class="Ftim-box" v-if="infolist">
    <div class="Ftim-bt">
      <span>至德-</span>企业长廊
      <i></i>
    </div>

    <div class="">
      <div class="Ftim-top">
        <div class="Ftim-current">
          <em></em>当前位置：
          <span>
            <router-link :to="{path:'/'}">首页</router-link> -- 
            <router-link :to="{path:'/economic',query:{tab:setnum}}">至德经济</router-link> -- 
            <router-link :to="{path:'/economic',query:{tab:settab}}">企业长廊</router-link> -- 
          </span>
          详情
        </div>
      </div>
    </div>

    <div class="Ftiminfo-cent">
      <div class="Spandaut-box">
        <div class="">
          <div class="Ftiminfo-title">{{infolist.company_name}}</div>
          <div class="Ftiminfo-intro">{{infolist.company_intro}}</div>
        </div>
        <div class="Ftiminfo-cover">
          <div class="swiper-container banner-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide item" v-for="(item, index) in infolist.company_album" :key="index">
                <img class="img" :src="item.url" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="Ftiminfo-info">
        <div class="Ftim-cent">
          <div class="Ftim-list" v-for="(item, index) in infolist.product" :key="index">
            <img :src="item.picture[0].url">
            <div class="Ftim-name">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</template>
<script>
import  Swiper  from "swiper"
export default {
  data() {
    return {
      setid:'',        //传过来的id
      settab:'',        //传过来的分类
      setnum:'',        //传过来的分类第一个
      infolist:[]
    };
  },
  created(){
    this.setid = this.$route.query.id;
    this.settab = this.$route.query.tab;
    this.setnum = this.$route.query.num;
    this.getData();
  },
  mounted() {
  },
  methods: {

    //获取详情数据
    getData(){
      this.$layer.loading();
      this.$http.get('company/'+this.setid).then((res)=>{
        if(res.data.code == 200){
          this.$layer.closeAll('loading');
          this.infolist = res.data.data;
          this.infolist.company_album = JSON.parse(res.data.data.company_album);
          this.$nextTick(()=>{
            this.bannerPoint()
          })
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },
    // 轮播
    bannerPoint() {
      new Swiper(".banner-container", {
        loop: this.infolist.company_album.length> 1 ? true : false,
        autoplay: {
          delay: 2000, //1秒切换一次
          // disableOnInteraction: false
        },
        updateOnImagesReady: true,
        slidesPerView: 1,  //设置slider容器能够同时显示的slides数量
        //spaceBetween : '10%',按container的百分比

        observer: true,//在 Swiper 的上启用动态检查器(Mutation Observer)，如果你更改swiper 的样式（隐藏/显示）或修改其子元素（添加/删除幻灯片），Swiper 会更新（重新初始化）并触发 observerUpdate 事件。
        observeParents: true,
        observeSlideChildren: true,
      })
    },
  },
};
</script>
<style scoped>
  .Ftim-box{
    background: url(../../../public/images/dysjbjt.png) top no-repeat;
    margin-bottom: 60px;
  }
  .Ftim-bt{
    width: 1200px;
    margin: 72px auto 0;
    font-weight: bold;
    font-size: 48px;
    color: #333;
    line-height: 48px;
  }
  .Ftim-bt span{
    color: #D71E1C;
  }
  .Ftim-bt i{
    display: block;
    width: 48px;
    height: 4px;
    background: #D71E1C;
    margin-top: 30px;
  }
  .Ftim-top{
    width: 1200px;
    height: 74px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    border-radius: 20px 20px 0px 0px;
    margin: 74px auto 0;
  }
  .Ftim-current{
    line-height: 74px;
    font-size: 16px;
    color: #333;
  }
  .Ftim-current em{
    display: inline-block;
    width: 12px;
    height: 12px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
    border-radius: 50%;
    margin: 0 10px 0 20px;
  }
  .Ftim-current span{
    color: #999;
  }
  .Ftim-current a{
    color: #999;
  }
  .Ftim-fanhui{
    width: 20px;
    height: 20px;
    margin-right: 30px;
    background: url(../../../public/images/fanhui.png) right center no-repeat;
    background-size: 20px 20px;
    cursor: pointer;
  }
  .Ftiminfo-cent{
    width: 1200px;
    margin: 40px auto 0;
  }
  .Spandaut-box{
    display: flex;
    justify-content: space-between;
    width: 1060px;
    height: 346px;
    background: #FDF7EF;
    border-radius: 16px;
    border: 1px solid #EBD8C4;
    margin: 30px auto 0;
    padding: 40px 30px 30px;
  }
  .Ftiminfo-title{
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    line-height: 32px;
  }
  .Ftiminfo-time{
    font-size: 16px;
    color: #999999;
    font-weight: 400;
    margin-top: 20px;
  }
  .Ftiminfo-intro{
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #333333;
    line-height: 32px;
    margin-top: 22px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 9; /* 定义显示的行数 */
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .Ftiminfo-cover{
    width: 280px;
    height: 346px;
    border-radius: 12px;
    margin-left: 30px;
  }
  .Ftiminfo-cover img{
    width: 280px;
    height: 346px;
    border-radius: 12px;
  }
  .Ftiminfo-info{
    margin-top: 22px;
  }

  .Ftim-cent{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
  }
  .Ftim-list{
    width: 285px;
    display: block;
    margin-top: 30px;
    margin-right: 0;
  }
  .Ftim-list:not(:nth-child(4n)){
    margin-right: 20px;
  }
  .Ftim-list img{
    width: 285px;
    height: 285px;
    border-radius: 12px;
  }
  .Ftim-name{
    font-size: 18px;
    color: #333333;
    line-height: 28px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 5px;
  }
</style>